import {API_URL, apiDelete} from '../api'

export const deletePostApi = async (id: string) => {
    return await apiDelete(API_URL, `admin/posts?postIDs=${id}`)
}
